import ProductBoxes from './ProductBoxes';

export default ProductBoxes;
